// TODO - replace with ADS QBE Icon

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

const AmexIcon = ({ fontSize }: SvgIconProps) => (
  <SvgIcon fontSize={fontSize}>
    <svg
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Foundation" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Iconography-/-Decorative" transform="translate(-426, -3198)" fillRule="nonzero">
          <g id="American-Express" transform="translate(426, 3198)">
            <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="0" y="0" width="48" height="48" />
            <rect id="Rectangle" fill="#1E8ECC" x="0" y="8" width="48" height="32" rx="4" />
            <polygon
              id="Fill-1"
              fill="#FFFFFF"
              points="30.4828945 21.5547817 30.4828945 23.1476726 34.8510268 23.1476726 34.8510268 24.9351821 30.4828945 24.9351821 30.4828945 26.67825 35.3749872 26.67825 37.6475611 24.1079407 35.4713608 21.5547817"
            />
            <polygon
              id="Fill-2"
              fill="#FFFFFF"
              points="9.1759304 24.7224736 11.8919645 24.7224736 10.5301208 21.2306707"
            />
            <path
              d="M40.6114879,18 L38.9684602,19.8710241 L37.429601,18 L27.9596218,18 L27.9596218,18.0061145 L22.4885791,18.0061145 L21.1924962,21.1616221 L19.8615488,18.0061145 L13.7774001,18.0061145 L13.7774001,19.4489774 L13.109021,18.0061145 L7.92029612,18.0061145 L3,30.2226521 L5.5110985,30.2226521 L8.91067631,30.2226521 L9.67712968,28.2770614 L11.3931462,28.2770614 L12.1577571,30.2226521 L18.8467918,30.2226521 L18.8467918,28.7353475 L19.443741,30.2289157 L22.9161659,30.2289157 L23.5132569,28.7129775 L23.5132569,30.2226521 L27.9596218,30.2226521 L27.9596218,30.2248891 L37.2279251,30.2248891 L38.9206986,28.3244857 L40.5156812,30.2248891 L44.1158011,30.2283191 L44.1158011,30.2289157 L45.7878826,30.2289157 L45.7878826,28.0942242 L42.4688051,24.1384683 L45.7878826,20.3977623 L45.7878826,18 L40.6114879,18 Z M41.4821097,19.7427696 L44.1094234,19.7427696 L40.2091282,24.1384683 L43.8721744,28.5043403 L41.3782247,28.5043403 L38.92821,25.6041485 L36.3821052,28.5043403 L34.0653129,28.5043403 L34.0653129,28.5021033 L28.5007311,28.5021033 L28.5007311,19.7429187 L32.9636779,19.7429187 L32.9636779,19.7427696 L36.5034226,19.7427696 L38.9513113,22.6146261 L41.4821097,19.7427696 Z M23.6806351,19.7429187 L26.993335,19.7429187 L26.993335,28.5021033 L24.9539001,28.5021033 L24.9463886,21.6419799 L22.0611339,28.5021033 L20.3142212,28.5021033 L17.4217384,21.6358654 L17.4217384,28.5021033 L13.3747569,28.5021033 L12.6102877,26.5484594 L8.46764133,26.5484594 L7.69523548,28.5021033 L5.53405809,28.5021033 L9.09718752,19.7429187 L12.0533052,19.7429187 L15.4374349,28.0360623 L15.4374349,19.7429187 L18.6845157,19.7429187 L21.2885863,25.6849787 L23.6806351,19.7429187 Z"
              id="Fill-3"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default AmexIcon;
